// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-state {
  align-items: center;
  display: flex;
  gap: 0.6rem;
  justify-content: center;
  min-height: 8rem;
}

.orders-manager .order-list + .order-list {
  margin-top: 1.5rem;
}

.orders-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
}

.orders-table button {
  white-space: nowrap;
}

.orders-table .warning {
  font-weight: 700;
}

.orders-empty {
  color: var(--text-muted, #666);
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Orders/Orders.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":[".orders-state {\n  align-items: center;\n  display: flex;\n  gap: 0.6rem;\n  justify-content: center;\n  min-height: 8rem;\n}\n\n.orders-manager .order-list + .order-list {\n  margin-top: 1.5rem;\n}\n\n.orders-table-wrapper {\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.orders-table button {\n  white-space: nowrap;\n}\n\n.orders-table .warning {\n  font-weight: 700;\n}\n\n.orders-empty {\n  color: var(--text-muted, #666);\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
